export const getProgressBarStyle = ({ palette = {} }) => ({
  '& .progress-text': {
    '& .spinner-header': {
      color: palette.neutralPrimary,
      fontSize: 14,
      fontWeight: 600,
    },
  },

  '& .progress': {
    backgroundColor: palette.neutralLight,
    marginTop: 7,
    '& .progress-bar': {
      backgroundColor: palette.themePrimary,
      height: 4,
    },
  },
});
